import { Box, Button, Typography } from "@mui/material";
import NoMembersIcon from "~/images/settings/NoMembersIcon";

interface Props {
  handleAddMemberClick?: () => void;
  isOrg?: boolean;
  isSearched?: boolean;
}

const MembersEmptyState = ({
  handleAddMemberClick,
  isOrg,
  isSearched,
}: Props) => {
  const scope = isOrg ? "organization" : "space";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 6,
        px: 2,
        textAlign: "center",
        bgcolor: "background.paper",
        borderRadius: 1,
        minHeight: 300,
      }}
    >
      <NoMembersIcon sx={{ width: "48px", height: "48px", mb: 1 }} />
      <Typography
        variant="h5"
        sx={{
          fontWeight: 700,
          color: "text.primary",
          mb: 1,
        }}
      >
        {isSearched ? `No members found` : `This ${scope} has no members`}
      </Typography>

      <Typography
        variant="body1"
        sx={{
          color: "text.secondary",
          mb: 1,
        }}
      >
        {isSearched
          ? `Your search did not match any members in this ${scope}.`
          : `There are currently no members in this ${scope}.`}
      </Typography>

      <Typography
        variant="body1"
        sx={{
          color: "text.secondary",
          mb: 3,
        }}
      >
        {isSearched
          ? `Try adjusting your search criteria.`
          : `Start collaborating with other users by inviting them to join you.`}
      </Typography>

      {handleAddMemberClick && !isSearched && (
        <Button
          variant="outlined"
          color="primary"
          onClick={handleAddMemberClick}
          sx={{
            textTransform: "uppercase",
            fontWeight: 500,
            px: 3,
          }}
        >
          Invite Member
        </Button>
      )}
    </Box>
  );
};

export default MembersEmptyState;
